import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const ShopByMobileFiltersBar = t0 => {
  const $ = _c(6);
  const {
    className,
    children,
    variant
  } = t0;
  const t1 = `lg:hidden px-5 py-3 md:px-[3.333vw] flex ${className}`;
  const t2 = variant === "collections-page";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = classNames(t1, {
      "max-md:!py-3 max-md:!px-[3.333vw]": t2
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
ShopByMobileFiltersBar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['collections-page'])
};
export default ShopByMobileFiltersBar;